var UtilMarket = /** @class */ (function () {
    function UtilMarket() {
        var _this = this;
        this.contractOrderFulfillable = function (order) {
            return order.total.greaterThanOrEqual(order.amount);
        };
        this.getContractTotalRewards = function (orders) {
            return orders.reduce(function (acc, val) { return acc + val.rewardPoints; }, 0);
        };
        this.getContractXp = function (orders, rewardShare) {
            var totalRewards = _this.getContractTotalRewards(orders);
            return Math.ceil(totalRewards * rewardShare.factor + (rewardShare.onTop || 0));
        };
    }
    return UtilMarket;
}());
export var utilMarket = new UtilMarket();



//////////////////
// WEBPACK FOOTER
// ./src/utils/market/utilMarket.ts
// module id = 834
// module chunks = 3